import {AdminBatchJobType} from '../../types/adminBatch.ts';

export type BatchJobGroup = 'BACKFILL' | 'QUALITY' | 'MAGIC_CARD' | 'LIBRARY_THUMBNAIL' | 'AI_IMAGE';

export type JobAction =
    | 'RETRY_FAILED'
    | 'REPROCESS_ALL_CACHED'
    | 'RESOLVE_STALE_CANCEL'
    | 'RESOLVE_STALE_RETRY';

export type SubmissionAction =
    | 'RECHECK'
    | 'CANCEL'
    | 'NEXT_PROVIDER'
    | 'RETRY_QUIZ'
    | 'RETRY_RESET'
    | 'REPROCESS_CACHED';

interface JobTypeConfig {
    group: BatchJobGroup;
    jobActions: JobAction[];
    submissionActions: SubmissionAction[];
}

const JOB_TYPE_CONFIG: Record<AdminBatchJobType, JobTypeConfig> = {
    DICTIONARY_METADATA_BACKFILL: {
        group: 'BACKFILL',
        jobActions: ['RESOLVE_STALE_CANCEL', 'RESOLVE_STALE_RETRY'],
        submissionActions: ['RECHECK', 'CANCEL', 'NEXT_PROVIDER'],
    },
    CONTENT_QUALITY_ANALYSIS: {
        group: 'QUALITY',
        jobActions: [],
        submissionActions: ['RECHECK', 'CANCEL'],
    },
    CONTENT_QUALITY_APPLY: {
        group: 'QUALITY',
        jobActions: [],
        submissionActions: ['RECHECK', 'CANCEL'],
    },
    WORDBOOK_MAGIC_CARD_GENERATION: {
        group: 'MAGIC_CARD',
        jobActions: ['RESOLVE_STALE_CANCEL', 'RESOLVE_STALE_RETRY'],
        submissionActions: ['RECHECK', 'CANCEL', 'NEXT_PROVIDER'],
    },
    LIBRARY_THUMBNAIL_GENERATION: {
        group: 'LIBRARY_THUMBNAIL',
        jobActions: ['RESOLVE_STALE_CANCEL'],
        submissionActions: ['RECHECK', 'CANCEL'],
    },
    AI_IMAGE_GENERATION: {
        group: 'AI_IMAGE',
        jobActions: ['RESOLVE_STALE_CANCEL'],
        submissionActions: ['RECHECK', 'CANCEL'],
    },
};

export const getJobGroup = (jobType: AdminBatchJobType): BatchJobGroup => {
    return JOB_TYPE_CONFIG[jobType].group;
};

export const supportsJobAction = (jobType: AdminBatchJobType, action: JobAction): boolean => {
    return JOB_TYPE_CONFIG[jobType].jobActions.includes(action);
};

export const supportsSubmissionAction = (jobType: AdminBatchJobType, action: SubmissionAction): boolean => {
    return JOB_TYPE_CONFIG[jobType].submissionActions.includes(action);
};
